/**
 * Returns the current scroll position scaled to the new content size, keeping the content at the supplied origin in place.
 */
export function getScaledScrollPosition(viewportScalingOrigin, scaledContentDimension, unitContentOrigin) {
    const newScrollPosition = scaledContentDimension * unitContentOrigin - viewportScalingOrigin;
    return newScrollPosition;
}
//# sourceMappingURL=get-scaled-scroll-position.js.map